/* unplugin-vue-components disabled */import { ElEmpty as __unplugin_components_11 } from 'element-plus/es';import 'element-plus/es/components/empty/style/css';
import { ElForm as __unplugin_components_10 } from 'element-plus/es';import 'element-plus/es/components/form/style/css';
import { ElFormItem as __unplugin_components_9 } from 'element-plus/es';import 'element-plus/es/components/form-item/style/css';
import { ElTooltip as __unplugin_components_8 } from 'element-plus/es';import 'element-plus/es/components/tooltip/style/css';
import __unplugin_components_7 from '~icons/ep/question-filled';
import { ElInput as __unplugin_components_6 } from 'element-plus/es';import 'element-plus/es/components/input/style/css';
import { ElIcon as __unplugin_components_5 } from 'element-plus/es';import 'element-plus/es/components/icon/style/css';
import __unplugin_components_4 from '~icons/ep/upload';
import { ElSelect as __unplugin_components_3 } from 'element-plus/es';import 'element-plus/es/components/select/style/css';
import { ElOption as __unplugin_components_2 } from 'element-plus/es';import 'element-plus/es/components/option/style/css';
import { ElCheckbox as __unplugin_components_1 } from 'element-plus/es';import 'element-plus/es/components/checkbox/style/css';
import { ElButton as __unplugin_components_0 } from 'element-plus/es';import 'element-plus/es/components/button/style/css';
import "core-js/modules/es.array.push.js";
import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, Teleport as _Teleport, openBlock as _openBlock, createBlock as _createBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-3f9ef6d2"), n = n(), _popScopeId(), n);
const _hoisted_1 = {
  class: "cascader-box"
};
const _hoisted_2 = {
  class: "left"
};
const _hoisted_3 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "支付方式", -1));
const _hoisted_4 = {
  class: "content"
};
const _hoisted_5 = ["onClick"];
const _hoisted_6 = ["src"];
const _hoisted_7 = {
  class: "right"
};
const _hoisted_8 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("div", {
  class: "header"
}, "参数配置", -1));
const _hoisted_9 = {
  class: "content"
};
const _hoisted_10 = {
  class: "flex items-center"
};
const _hoisted_11 = {
  key: 0,
  class: "flex flex-wrap items-center"
};
const _hoisted_12 = {
  key: 0,
  class: "callback"
};
const _hoisted_13 = {
  key: 1,
  class: "callback"
};
const _hoisted_14 = {
  key: 0
};
const _hoisted_15 = {
  style: {
    "margin-bottom": "10px"
  }
};
const _hoisted_16 = /*#__PURE__*/_withScopeId(() => /*#__PURE__*/_createElementVNode("span", {
  class: "marginL10"
}, "上传p12文件，用于生成私钥", -1));
const _hoisted_17 = ["innerHTML"];
const _hoisted_18 = {
  key: 0,
  id: "input-file-p12",
  class: "input-file",
  type: "file"
};
import UseConfig from '../configHook';
import UseLoginPay from '../loginPayHooks';
import { copyText } from '@ultra/share/utils';
import { apiUsdkGetGoodsConfEdit, apiUsdkSaveGlobalPaySwitchConf } from '@/api/usdk';
import TipsModal from '@ultra/share/components/UTipsModal/index.vue';
import { customDataReport } from '@/utils/dataReport';
export default /*#__PURE__*/_defineComponent({
  __name: 'globalPay',
  props: {
    gid: {
      type: [Number, String],
      required: true,
      default: 0
    },
    channel: {
      type: Object,
      required: true,
      default: () => ({})
    },
    payParams: {
      type: Object,
      default: () => ({})
    }
  },
  emits: ['ok'],
  setup(__props, {
    emit: emits
  }) {
    const props = __props;
    const SDK_NAME = ref(process.env.VUE_APP_SDK_NAME);
    const {
      globalPay,
      globalPayIcon,
      GlobalPayConfigDict
    } = UseConfig();
    const {
      rules
    } = UseLoginPay();
    const form = ref({});
    const oldForm = ref({});
    const confirmLoading = ref(false);
    watch(() => props.payParams, _params => {
      console.log('_params========>', _params);
      let params = {
        ..._params
      };
      if (params.cid) {
        // let typeArr = globalPay.map(item => item.key).sort();
        let typeArr = [1, 2, 10, 11, 12, 13, 14, 15, 17, 18, 19, 21, 27, 28, 30, 31];
        typeArr.forEach(t => {
          if (!params[`type${t}Conf`]) {
            params[`type${t}Conf`] = {};
            GlobalPayConfigDict[t].configKeys.forEach(p => {
              params[`type${t}Conf`][p.key] = '';
            });
          }
        });
        form.value = {
          ...params
        };
        oldForm.value = JSON.parse(JSON.stringify(params));
        // console.log(this.form);
      }
    }, {
      immediate: true
    });
    const currentPay = ref({});
    const handleClick = params => {
      currentPay.value = params;
    };
    const tipsModal = ref();
    const handleShowDesc = data => {
      if (data.html) {
        var _tipsModal$value;
        (_tipsModal$value = tipsModal.value) === null || _tipsModal$value === void 0 ? void 0 : _tipsModal$value.show(data.html);
      }
    };
    const copyCallback = callback => {
      copyText(callback).then(() => {
        ElMessage.success('复制成功');
      });
    };
    // const callback = (type: 1 | 2, pid: number) => {
    // 	let prefix = {
    // 		1: 'https://hglobal.ultrasdk.com/hgsdk/v1/pay/as/iapntf/' + pid, // AppStore
    // 		2: 'https://hglobal.ultrasdk.com/hgsdk/gp/iapntf/' + pid // GooglePlay
    // 	};
    // 	return prefix[type];
    // };
    const comparePayOpen = () => {
      const typeArr = [1, 2, 10, 11, 12, 13, 14, 15, 17, 18, 19, 21, 27, 28, 30];
      console.log('oldForm====>', oldForm.value);
      let tempArr = [];
      typeArr.forEach(t => {
        if (oldForm.value[`type${t}`] !== form.value[`type${t}`] && form.value[`type${t}`] === 1) {
          tempArr.push(t);
        }
      });
      return tempArr;
    };
    // 获取商品配置
    const getGoodsConf = async typeArr => {
      let countObj = {};
      const res = await apiUsdkGetGoodsConfEdit({
        gid: props.gid,
        cid: props.channel.cid
      });
      console.log('data', res.data);
      if (res.code === 0) {
        let data = res.data;
        typeArr.forEach(item => {
          data.forEach(p => {
            if (!p[`payType${item}`] || p[`payType${item}`] && p[`payType${item}`].goodsId === '') {
              countObj[item] = countObj[item] ? countObj[item] + 1 : 1;
            }
          });
        });
      }
      console.log('countObj', countObj);
      return countObj;
    };
    const ruleForm = ref();
    const showInputFile = ref(true);
    const getDict = () => {
      const dict = {};
      globalPay.map(item => {
        dict[`type${item.key}Conf`] = {
          name: item.value
        };
        dict[`type${item.key}`] = {
          name: item.value + '-开关（0:关；1:开）'
        };
      });
      const typeArr = [1, 2, 10, 11, 12, 13, 14, 15, 17, 18, 19, 21, 27, 28, 30];
      typeArr.forEach(t => {
        dict[`type${t}Conf`].params = GlobalPayConfigDict[t].configKeys;
      });
      return dict;
    };
    const handleSubmit = async () => {
      const dict = getDict();
      const result = comparePayOpen();
      console.log('result', result);
      let msg = '';
      if (!!result.length) {
        const res = await getGoodsConf(result);
        console.log('res===>', res);
        globalPay.forEach(item => {
          if (result.includes(item.key)) {
            msg += `<br/><span style="color: #e99840">${item.value}：该支付方式还有${res[item.key] || 0}个商品ID没有配置，请及时检查并配置</span>。`;
          }
        });
      }
      ElMessageBox.confirm(`你正在编辑修改${props.channel.name}渠道支付开关/参数，修改后将直接立即影响线上游戏支付，请务必确认操作无误后再保存，否则因此导致的线上游戏支付事故后果自负！
    ${msg}
    `, '提示', {
        customStyle: {
          width: '800px'
        },
        confirmButtonText: '取消，不保存',
        cancelButtonText: '确认保存',
        dangerouslyUseHTMLString: true,
        distinguishCancelAndClose: true,
        type: 'warning'
      }).then(() => {
        // to do
      }).catch(action => {
        if (action === 'cancel') {
          confirmLoading.value = true;
          return apiUsdkSaveGlobalPaySwitchConf({
            ...form.value,
            gid: props.gid
          }).then(res => {
            if (res.code === 0) {
              emits('ok');
              customDataReport({
                eventName: 'set_global_pay_switch_params',
                dict,
                before: oldForm.value,
                after: form.value,
                operatePath: '运营-登录支付配置-支付和商品管理-全球支付',
                gid: props.gid
              });
              oldForm.value = JSON.parse(JSON.stringify(form.value));
            }
          }).finally(() => {
            confirmLoading.value = false;
          });
        }
      });
    };
    const onChangeP12 = p => {
      let $input = document.getElementById('input-file-p12');
      $input.onchange = e => {
        let file = e.target.files[0] || null;
        if (!file) return;
        let fileExtension = file.name.substring(file.name.lastIndexOf('.') + 1);
        console.log(fileExtension);
        if (fileExtension !== 'p12') {
          ElMessage('请上传.p12结尾的文件');
          return;
        }
        let reader = new FileReader();
        reader.onload = evt => {
          console.log(evt.target.result);
          let res = evt.target.result;
          res = res.replace('data:application/x-pkcs12;base64,', '');
          form.value[`type${currentPay.value.key}Conf`].p12 = res;
          ElMessage.success('解析成功！');
          showInputFile.value = false;
          setTimeout(() => {
            showInputFile.value = true;
          }, 200);
        };
        reader.readAsDataURL(file);
      };
      $input.click();
    };
    return (_ctx, _cache) => {
      const _component_el_button = __unplugin_components_0;
      const _component_el_checkbox = __unplugin_components_1;
      const _component_u_question = _resolveComponent("u-question");
      const _component_el_option = __unplugin_components_2;
      const _component_el_select = __unplugin_components_3;
      const _component_i_ep_Upload = __unplugin_components_4;
      const _component_el_icon = __unplugin_components_5;
      const _component_el_input = __unplugin_components_6;
      const _component_i_ep_question_filled = __unplugin_components_7;
      const _component_el_tooltip = __unplugin_components_8;
      const _component_el_form_item = __unplugin_components_9;
      const _component_el_form = __unplugin_components_10;
      const _component_el_empty = __unplugin_components_11;
      return _openBlock(), _createElementBlock(_Fragment, null, [(_openBlock(), _createBlock(_Teleport, {
        to: "#globalPay"
      }, [_createVNode(_component_el_button, {
        loading: _unref(confirmLoading),
        type: "primary",
        onClick: handleSubmit
      }, {
        default: _withCtx(() => [_createTextVNode("保存")]),
        _: 1
      }, 8, ["loading"])])), _createElementVNode("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_hoisted_3, _createElementVNode("div", _hoisted_4, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(globalPay), item => {
        var _unref$item$key, _unref$item$key2;
        return _openBlock(), _createElementBlock(_Fragment, {
          key: item.key
        }, [__props.channel.plat > 0 || __props.channel.plat == 0 && item.key != 1 ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: _normalizeClass(['check-item', item.key === _unref(currentPay).key ? 'active-check-item' : '']),
          onClick: $event => handleClick(item)
        }, [_createVNode(_component_el_checkbox, {
          modelValue: _unref(form)['type' + item.key],
          "onUpdate:modelValue": $event => _unref(form)['type' + item.key] = $event,
          "false-label": 0,
          "true-label": 1,
          class: "marginR5"
        }, null, 8, ["modelValue", "onUpdate:modelValue"]), _createElementVNode("img", {
          src: _unref(globalPayIcon)[item.key],
          style: {
            "margin-right": "3px"
          },
          width: "20"
        }, null, 8, _hoisted_6), _createTextVNode(_toDisplayString(item.value) + " ", 1), (_unref$item$key = _unref(GlobalPayConfigDict)[item.key]) !== null && _unref$item$key !== void 0 && _unref$item$key.tips ? (_openBlock(), _createBlock(_component_u_question, {
          key: 0,
          content: (_unref$item$key2 = _unref(GlobalPayConfigDict)[item.key]) === null || _unref$item$key2 === void 0 ? void 0 : _unref$item$key2.tips
        }, null, 8, ["content"])) : _createCommentVNode("", true)], 10, _hoisted_5)) : _createCommentVNode("", true)], 64);
      }), 128))])]), _createElementVNode("div", _hoisted_7, [_hoisted_8, _createElementVNode("div", _hoisted_9, [_createVNode(_component_el_form, {
        ref_key: "ruleForm",
        ref: ruleForm,
        model: _unref(form),
        "label-width": "170px"
      }, {
        default: _withCtx(() => [_unref(GlobalPayConfigDict)[_unref(currentPay).key] ? (_openBlock(), _createElementBlock("div", {
          key: _unref(currentPay).key + 1,
          class: "params-box"
        }, [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(GlobalPayConfigDict)[_unref(currentPay).key].configKeys, p => {
          return _openBlock(), _createBlock(_component_el_form_item, {
            key: p.key,
            label: p.label,
            prop: [`type${_unref(currentPay).key}Conf`] + '.' + [p.key],
            rules: _unref(rules)(p)
          }, {
            default: _withCtx(() => [_createElementVNode("div", _hoisted_10, [!p.render ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 0
            }, [p.key === 'callbackUrl' && p.type === 'copy' ? (_openBlock(), _createElementBlock("div", _hoisted_11, [_unref(form)[`type${_unref(currentPay).key}Conf`][p.key] ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_unref(form)[`type${_unref(currentPay).key}Conf`][p.key]), 1)) : (_openBlock(), _createElementBlock("div", _hoisted_13, "暂无回调地址")), _unref(form)[`type${_unref(currentPay).key}Conf`][p.key] ? (_openBlock(), _createBlock(_component_el_button, {
              key: 2,
              link: "",
              size: "small",
              type: "primary",
              onClick: $event => copyCallback(_unref(form)[`type${_unref(currentPay).key}Conf`][p.key])
            }, {
              default: _withCtx(() => [_createTextVNode("复制")]),
              _: 2
            }, 1032, ["onClick"])) : _createCommentVNode("", true)])) : p.options ? (_openBlock(), _createBlock(_component_el_select, {
              key: 1,
              modelValue: _unref(form)[`type${_unref(currentPay).key}Conf`][p.key],
              "onUpdate:modelValue": $event => _unref(form)[`type${_unref(currentPay).key}Conf`][p.key] = $event
            }, {
              default: _withCtx(() => [(_openBlock(true), _createElementBlock(_Fragment, null, _renderList(p.options, op => {
                return _openBlock(), _createBlock(_component_el_option, {
                  key: op.value,
                  label: op.label,
                  value: op.value
                }, null, 8, ["label", "value"]);
              }), 128))]),
              _: 2
            }, 1032, ["modelValue", "onUpdate:modelValue"])) : (_openBlock(), _createElementBlock(_Fragment, {
              key: 2
            }, [_unref(currentPay).key === 2 && p.key === 'p12' ? (_openBlock(), _createElementBlock("div", _hoisted_14, [_createElementVNode("div", _hoisted_15, [_createVNode(_component_el_button, {
              class: "upload-btn ant-btn",
              plain: "",
              type: "primary",
              onClick: $event => onChangeP12(p)
            }, {
              default: _withCtx(() => [_createVNode(_component_el_icon, null, {
                default: _withCtx(() => [_createVNode(_component_i_ep_Upload)]),
                _: 1
              }), _createTextVNode(" " + _toDisplayString(_unref(form)[`type${_unref(currentPay).key}Conf`].p12 ? '重新上传' : '点击上传'), 1)]),
              _: 2
            }, 1032, ["onClick"]), _hoisted_16]), _createVNode(_component_el_input, {
              modelValue: _unref(form)[`type${_unref(currentPay).key}Conf`].p12,
              "onUpdate:modelValue": _cache[0] || (_cache[0] = $event => _unref(form)[`type${_unref(currentPay).key}Conf`].p12 = $event),
              placeholder: "上传P12文件后自动生成"
            }, null, 8, ["modelValue"])])) : (_openBlock(), _createBlock(_component_el_input, {
              key: 1,
              modelValue: _unref(form)[`type${_unref(currentPay).key}Conf`][p.key],
              "onUpdate:modelValue": $event => _unref(form)[`type${_unref(currentPay).key}Conf`][p.key] = $event,
              placeholder: `请输入${p.label}`
            }, null, 8, ["modelValue", "onUpdate:modelValue", "placeholder"]))], 64))], 64)) : (_openBlock(), _createElementBlock("div", {
              key: 1,
              class: "callback",
              style: {
                "max-width": "360px"
              },
              innerHTML: p.render(_unref(form)[`type${_unref(currentPay).key}Conf`])
            }, null, 8, _hoisted_17)), p.tips || p.html ? (_openBlock(), _createElementBlock(_Fragment, {
              key: 2
            }, [p.tips ? (_openBlock(), _createBlock(_component_el_tooltip, {
              key: 0,
              placement: "top"
            }, {
              content: _withCtx(() => [_createTextVNode(_toDisplayString(p.tips), 1)]),
              default: _withCtx(() => [_createVNode(_component_el_icon, {
                size: 20,
                class: "marginL10 cp",
                color: "#f59a23"
              }, {
                default: _withCtx(() => [_createVNode(_component_i_ep_question_filled)]),
                _: 1
              })]),
              _: 2
            }, 1024)) : (_openBlock(), _createBlock(_component_el_icon, {
              key: 1,
              size: 20,
              class: "marginL10 cp",
              color: "#f59a23",
              onClick: $event => handleShowDesc(p)
            }, {
              default: _withCtx(() => [_createVNode(_component_i_ep_question_filled)]),
              _: 2
            }, 1032, ["onClick"]))], 64)) : _createCommentVNode("", true)])]),
            _: 2
          }, 1032, ["label", "prop", "rules"]);
        }), 128))])) : _createCommentVNode("", true)]),
        _: 1
      }, 8, ["model"]), !_unref(GlobalPayConfigDict)[_unref(currentPay).key] ? (_openBlock(), _createBlock(_component_el_empty, {
        key: 0,
        description: `请联系${_unref(SDK_NAME)}对接人配置参数`
      }, null, 8, ["description"])) : _createCommentVNode("", true)])])]), _createVNode(TipsModal, {
        ref_key: "tipsModal",
        ref: tipsModal
      }, null, 512), _unref(showInputFile) ? (_openBlock(), _createElementBlock("input", _hoisted_18)) : _createCommentVNode("", true)], 64);
    };
  }
});